"use client";
import React from "react";
// importing redux
import type { RootState } from "../GlobalRedux/Store";
import { useSelector } from "react-redux";

import BlogHeader from "./Components/BlogHeader";
import BlogFooter from "./Components/BlogFooter";
import UserNotVerified from "../(Global)/Components/UserNotVerified";
import useAuthStatus from "../auth/hook/useAuthStatus";
import { useGetUserProfileServiceQuery } from "../GlobalRedux/features/auth/authApi";

export default function DashboardLayout({
  children, // will be a page or nested layout
}: {
  children: React.ReactNode;
}) {

  const theme = useSelector((state: RootState) => state.theme.themeValue);

  const { isLoggedIn, isLoading: isLoadingUser } = useAuthStatus();
  const { data: user } = useGetUserProfileServiceQuery(undefined);

  return (
    <main className="">
      <BlogHeader
        theme={theme}
        user={user}
        isLoggedIn={isLoggedIn}
        isLoadingUser={isLoadingUser}
      />
      {user?.userIsVerified === false && <UserNotVerified />}
      {children}
      <BlogFooter theme={theme} />
    </main>
  );
}
